(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["knx-product-accessories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('knx-accessories')) {
    class KnxAccessories extends HTMLElement {
      connectedCallback() {
        this.addEventListener('submit', (event) => this.sync(event.target));
      }

      // Read the buy box at submit time: the variant picker may have changed since render.
      sync(form) {
        const buyForm = document.querySelector(
          `product-form-component[data-product-id="${this.dataset.productId}"]`
        );
        const mainId = buyForm?.querySelector('input[name="id"]')?.value;
        const qty = Math.max(1, parseInt(buyForm?.querySelector('input[name="quantity"]')?.value, 10) || 1);
        if (mainId) form.querySelector('[data-main-id]').value = mainId;
        form.querySelector('[data-main-qty]').value = qty;
        form.querySelector('[data-acc-qty]').value = form.dataset.perUnit === 'true' ? qty : 1;

        const mainOptions = this.readJson('[data-main-options]');
        const accOptions = this.readJson('[data-acc-options]', form);
        const option = mainOptions[mainId];
        if (option && accOptions[option]) form.querySelector('[data-acc-id]').value = accOptions[option];
      }

      readJson(selector, root = this) {
        try {
          return JSON.parse(root.querySelector(selector)?.textContent || '{}');
        } catch {
          return {};
        }
      }
    }

    customElements.define('knx-accessories', KnxAccessories);
  }
  } catch(e) { console.error(e); }
})();

})();
